/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation eventEntityRelationRemoveMutation($event: EventReferenceInput!, $entity: EntityReferenceInput!, $relationDefinition: ID!) {
        payload: eventEntityRelationRemove(event: $event, entity: $entity, relationDefinition: $relationDefinition)
    }
`;
